import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CONFIGURATION } from '../app.constants';
import { Observable } from 'rxjs';

declare var config: any;
@Injectable({ providedIn: 'root' })
export class DashboardService {
    constructor(private http: HttpClient) { }
    private AdmtServiceUrl = CONFIGURATION.baseUrls.ADMTServiceURL;

    getDealersCountBySource(): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getdealerscountbysource';
        return this.http.get(url);
    }
    getDealersCountByClient(): Observable<any> {
        const url = this.AdmtServiceUrl + 'client-subscription/getdealerscountbyclient';
        return this.http.get(url);
    }
    getTotalDataProcessed(): Observable<any>{
        const url = this.AdmtServiceUrl + 'client-subscription/gettotaldataprocessed';
        return this.http.get(url);
    }
    getTotalNoOfIssues(): Observable<any>{
        const url = this.AdmtServiceUrl + 'client-subscription/totalnoofissuesget';
        return this.http.get(url);
    }
    dealerCountByOemGet(): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/dealercountbyoemget';
        return this.http.get(url);
    }
    totalDealerCount(): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/totaldealercount';
        return this.http.get(url);
    }
}